// src/components/img/GalerySectionVessels/VesselMilady.tsx
import React from 'react';
import vesselImage from './milady.jpeg';

const VesselMilady: React.FC = () => (
  <img src={vesselImage} alt="Vessel Milady" />
);

export default VesselMilady;